import React from 'react';
import styled from 'styled-components';
import { Text } from '@catalogo/theme-text';
import { getIn } from 'seamless-immutable';
import PropTypes from 'prop-types';
import IconAlertWarning from '@catalogo/ui-americanas-desktop-svg/alert.svg';
import { getFreightErrorMessage } from '../helpers/freight';

const FreightErrors = ({ error }) => {
  const errorCode = getIn(error, ['errorCode']);
  const errorMessage = getFreightErrorMessage(errorCode);

  if (error) {
    return (
      <AlertUI>
        <IconWarning />
        <TextWarning>{errorMessage.message}</TextWarning>
      </AlertUI>
    );
  }

  return null;
};

const AlertUI = styled.div`
  display: flex;
  align-items: center;
  gap: 0 16px;
  width: 100%;
  background-color: ${({ theme }) => theme.warning.light};
  margin-top: 10px;
  padding: 16px;
  border-radius: 8px;
`;

const TextWarning = styled(Text)`
  font-size: 14px;
  line-height: 18px;
  color: ${({ theme }) => theme.grey.darker};
`;

const IconWarning = styled(IconAlertWarning)`
  min-width: 20px;
  fill: ${({ theme }) => theme.grey.darker};
`;

FreightErrors.propTypes = {
  data: PropTypes.object,
};

export default FreightErrors;
